import { useState, useRef, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import Calendar2LineIcon from "remixicon-react/Calendar2LineIcon";
import DatePicker from "react-datepicker";
import Button from "../../../components/utils/Button";
import { useForm } from "react-hook-form";
import moment from "moment";
import CardLayout from "../../../components/utils/CardLayout";
import SearchBar from "../../../components/utils/SearchBar";
import "react-datepicker/dist/react-datepicker.css";
import Table from "../../../components/utils/Table";
import networkActions from "../../../redux/network/actions";
import { isAdmin, isAdminAgent } from "../../../helpers/commonFunction";
import shortCodeActions from "../../../redux/shortCodeData/actions";
import DownloadCloud2sLineIcon from "remixicon-react/DownloadCloud2LineIcon";
import chatrRechargeReportActions from "../../../redux/ChatrRechargeReport/actions";
import { convertDateTimeToRequiredFormatTZ } from "../../../helpers/commonFunction";
import * as XLSX from "xlsx";
import FileSaver from "file-saver";
import Tag from "../../../components/utils/Tag";
import dealerAction from "../../../redux/dealer/actions";

function ChatrRechargeReport() {
  const dispatch = useDispatch();
  const { getShortCode } = shortCodeActions;
  const { getActiveNetwork } = networkActions;
  const { getDealer } = dealerAction;
  const { tokenData } = useSelector((state) => state.auth);
  const { networkResult } = useSelector((state) => state.network);
  const dealerResult = useSelector((state) => state.dealer.dealerResult);
  const [filterText, setFilterText] = useState("");
  const [toDate, setToDate] = useState(new Date());
  const [fromDate, setFromDate] = useState(
    new Date(new Date().getTime() - 2 * 24 * 60 * 60 * 1000),
  );
  const [searchData, setSearchData] = useState({
    statusID: "",
    msisdn: "",
    fromDate: moment(fromDate).format("YYYY-MM-DD"),
    toDate: moment(toDate).format("YYYY-MM-DD"),
    dealerID: "",
    networkID: "",
  });
  const {
    register: registerFilter,
    handleSubmit: handleSubmit,
    reset,
    setValue: setValueFilter,
  } = useForm({ defaultValues: searchData });
  const { shortCodeResult } = useSelector((state) => state.shortCode);

  const { getChatrRechargeReportRequestList } = chatrRechargeReportActions;
  const { chatrRechargeReportResult, loading } = useSelector(
    (state) => state.chatrRechargeReport,
  );

  const fileType =
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
  const fileExtension = ".xlsx";

  useEffect(() => {
    if (networkResult.length == 1) {
      reset({
        networkID: "1",
      });
    }
  }, [networkResult]);

  const activeNetworks = networkResult?.filter(
    (item) => item.IsActive == 1 && item.ID == 1,
  );

  useEffect(() => {
    if (activeNetworks?.length === 1) {
      setValueFilter("networkID", activeNetworks[0].ID);
    }
  }, [networkResult]);

  useEffect(() => {
    dispatch(getActiveNetwork());
    dispatch(getDealer());
    dispatch(
      getShortCode({
        tableName: "activationrequest",
        fieldName: "RequestStatus",
      }),
    );
    dispatch(getChatrRechargeReportRequestList(searchData));
  }, []);

  const handleFilterChange = (value) => {
    setFilterText(value);
  };
  const datePickerRef = useRef(null);
  const datePickerRef2 = useRef(null);
  const openDatePicker = () => {
    datePickerRef.current.setOpen(true);
  };
  const openDatePicker2 = () => {
    datePickerRef2.current.setOpen(true);
  };
  const onSubmit = (data) => {
    const newData = {
      ...data,
      toDate: moment(toDate).format("YYYY-MM-DD"),
      fromDate: moment(fromDate).format("YYYY-MM-DD"),
    };
    setSearchData(newData);
    dispatch(getChatrRechargeReportRequestList(newData));
  };

  const columns = [
    { displayName: "#", key: "key" },
    { displayName: "BULK TRANSACTION ID", key: "bulkTransactionID" },
    { displayName: "TRANSACTION ID", key: "transactionID" },
    { displayName: "MSISDN", key: "MSISDN" },
    { displayName: "PIN 1", key: "pin1" },
    { displayName: "PIN 2", key: "pin2" },
    { displayName: "AMOUNT", key: "amount" },
    { displayName: "DEALER", key: "dealer" },
    { displayName: "NETWORK", key: "network" },
    { displayName: "PLAN NAME", key: "planName" },
    { displayName: "DATE", key: "date" },
    { displayName: "STATUS", key: "status" },
    { displayName: "REMARKS", key: "remarks" },
  ];

  const filteredItems = Array.isArray(chatrRechargeReportResult)
    ? chatrRechargeReportResult.filter((item) =>
        Object.values(item).some(
          (value) =>
            typeof value === "string" &&
            value.toLowerCase().includes(filterText.toLowerCase()),
        ),
      )
    : [];

  const dataSource = filteredItems.map((item, key) => ({
    key: key + 1,
    bulkTransactionID: item.BulkTransactionID,
    transactionID: item.TransactionID,
    MSISDN: item.MSISDN,
    pin1: item.PIN1,
    pin2: item.PIN2,
    amount: `$${item.AmountCharged.toFixed(2)}`,
    dealer: item.DealerName,
    network: item.NetworkName,
    planName: item.PlanName,
    date:
      item.RequestedDtTm !== null
        ? convertDateTimeToRequiredFormatTZ(item.RequestedDtTm)
        : "",
    status: (
      <Tag
        color={
          item.RequestStatus === 13
            ? "badge-danger"
            : item.RequestStatus === 11
              ? "badge-warning"
              : item.RequestStatus === 12
                ? "badge-success"
                : item.RequestStatus === 32
                  ? "badge-secondary"
                  : "badge-secondary"
        }
        title={item.RequestStatusDesc}
      />
    ),
    remarks: item.Remark,
  }));

  const listDataModel =
    chatrRechargeReportResult?.map((item, key) => ({
      "Sr. No": key + 1,
      BulkTransactionID: item.BulkTransactionID,
      TransactionID: item.TransactionID,
      MSISDN: item.MSISDN,
      PIN1: item.PIN1,
      PIN2: item.PIN2,
      Amount: `$${item.AmountCharged.toFixed(2)}`,
      Dealer: item.DealerName,
      Network: item.NetworkName,
      PlanName: item.PlanName,
      Date:
        item.RequestedDtTm !== null
          ? convertDateTimeToRequiredFormatTZ(item.RequestedDtTm)
          : "",
      Status: item.RequestStatusDesc,
      Remark: item.Remark,
    })) || [];

  const exportToCSVModal = async () => {
    if (listDataModel && listDataModel.length > 0) {
      const ws = XLSX.utils.json_to_sheet(listDataModel);
      const wb = {
        Sheets: { chatrRechargeReportList: ws },
        SheetNames: ["chatrRechargeReportList"],
      };
      const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
      const data = new Blob([excelBuffer], { type: fileType });
      await FileSaver.saveAs(data, "Chatr_Recharge_Report" + fileExtension);
    }
  };

  return (
    <>
      <CardLayout title="Chatr Recharge Report">
        <form onSubmit={handleSubmit(onSubmit)}>
          <div className="form-row">
            <div className="col-lg-2 col-md-4 mb-2">
              <label>Select Network</label>
              <select
                className="form-control"
                id="networkID"
                name="networkID"
                {...registerFilter("networkID", {})}
              >
                {/* <option value="">All</option> */}
                {networkResult &&
                  networkResult.length > 0 &&
                  networkResult
                    .filter((item) => item.IsActive == 1 && item.ID == 1)
                    .map((item) => {
                      return (
                        <option value={item.ID}>{item.NetworkName}</option>
                      );
                    })}
              </select>
            </div>
            <div className="col-lg-2 col-md-4 mb-2">
              <label>Select Status</label>
              <select className="form-control" {...registerFilter("statusID")}>
                <option value="">Select</option>

                {shortCodeResult
                  ?.filter(
                    (item) =>
                      item.IsActive == 1 &&
                      [10, 11, 12, 13, 32].includes(Number(item.ID)),
                  )
                  .map((item) => (
                    <option key={item.ID} value={item.ID}>
                      {item.Value}
                    </option>
                  ))}
              </select>
            </div>

            {(isAdmin(tokenData) || isAdminAgent(tokenData)) && (
              <div className="col-lg-2 col-md-4  mb-2">
                <label>Select Dealer</label>
                <select
                  className="form-control"
                  id="dealerID"
                  name="dealerID"
                  {...registerFilter("dealerID", {})}
                >
                  <option value="" name="All">
                    All
                  </option>
                  {dealerResult &&
                    dealerResult.length &&
                    dealerResult
                      .filter((item) => item.IsActive == 1 && item.ID !== 1)
                      .map((item) => {
                        return (
                          <option value={item.ID} key={`dealer${item.ID}`}>
                            {item.DealerName}
                          </option>
                        );
                      })}
                </select>
              </div>
            )}

            <div className="col-lg-2 col-md-4 mb-2 d-flex flex-column">
              <label>From Date</label>
              <Calendar2LineIcon
                onClick={openDatePicker}
                size={"1.5rem"}
                style={{
                  cursor: "pointer",
                  position: "absolute",
                  top: "36px",
                  right: "12px",
                  zIndex: 1,
                }}
              />
              <DatePicker
                ref={datePickerRef}
                selected={fromDate}
                className="form-control"
                onChange={(date) => setFromDate(date)}
                dateFormat="yyyy-MM-dd"
                name="fromDate"
                showMonthDropdown
                showYearDropdown
                onKeyDown={(e) => {
                  e.preventDefault();
                }}
                value={fromDate}
              />
            </div>

            <div className="col-lg-2 col-md-4 mb-2 d-flex flex-column">
              <label>To Date</label>
              <Calendar2LineIcon
                onClick={openDatePicker2}
                size={"1.5rem"}
                style={{
                  cursor: "pointer",
                  position: "absolute",
                  top: "36px",
                  right: "12px",
                  zIndex: 1,
                }}
              />
              <DatePicker
                ref={datePickerRef2}
                selected={toDate}
                className="form-control center"
                onChange={(date) => setToDate(date)}
                dateFormat="yyyy-MM-dd"
                name="todate"
                showMonthDropdown
                showYearDropdown
                onKeyDown={(e) => {
                  e.preventDefault();
                }}
                value={toDate}
              />
            </div>

            <div className="col-lg-2 col-md-4 mb-2">
              <label>Mobile/TXN</label>
              <input
                type="text"
                className="form-control"
                id="MSISDN"
                name="MSISDN"
                placeholder="Mobile/TXN"
                {...registerFilter("msisdn")}
              />
            </div>

            <div
              className={
                isAdmin(tokenData) || isAdminAgent(tokenData)
                  ? "col-lg-2 col-md-4 mb-2"
                  : "col-lg-2 col-md-4"
              }
            >
              <div
                className={
                  isAdmin(tokenData) || isAdminAgent(tokenData)
                    ? "mt-2 d-flex justify-content-start activation-search-btn"
                    : "mt-4"
                }
              >
                <Button
                  title="Search"
                  loading={loading}
                  style="minWidth:80px"
                  buttonClass={`btn btn-primary mt-1 btn-md Activity_searchBtn__GlBtC`}
                  buttonType="submit"
                />
              </div>
            </div>
          </div>
        </form>
        <hr />

        <div className="row mb-3  ">
          <div className="col-lg-3  activation-request-search-btn mb-sm-444">
            <SearchBar onFilter={handleFilterChange} filterText={filterText} />
          </div>
        </div>

        <div className="d-flex justify-content-end mb-3">
          {dataSource && dataSource.length > 0 && (
            <Button
              onClick={exportToCSVModal}
              title="Export"
              icon={<DownloadCloud2sLineIcon size={15} />}
              style={{ minWidth: "120px" }}
              buttonClass="btn acti-export-btn-v acti-ex-btn font-weight-bold text-white"
            />
          )}
        </div>

        <div id="text-center">
          <Table
            columns={columns}
            loading={loading}
            data={dataSource}
            pagination={true}
          />
          ;
        </div>
      </CardLayout>
    </>
  );
}

export default ChatrRechargeReport;
